import { SaleModel } from 'api-hooks/sale/common';
import { AuthorizationRules } from 'common/constants';
import { SaleStatusEnum } from 'common/constants/enum';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDialog from 'hooks/use-dialog';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import AddToProjectModal from '../component/add-to-project-modal';

export default function useSalesAddToProject(data: SaleModel) {
  const { t } = useTranslation();
  const { can } = useAuthorization();

  const dialog = useDialog();

  const permission = AuthorizationRules.SalesAddToProject;
  const status = data.status;
  const hasProject = !!data.project;

  const isAllowed = React.useMemo(() => {
    switch (status) {
      case SaleStatusEnum.Active:
      case SaleStatusEnum.Completed:
      case SaleStatusEnum.OpenTicket:
      case SaleStatusEnum.Rescheduled:
      case SaleStatusEnum.Refund:
        return !hasProject;
      default:
        return false;
    }
  }, [hasProject, status]);

  const addToProjectPermission = isAllowed && can(permission);

  const onAddProject = React.useCallback(() => {
    dialog.showCustom({
      render: (onClose) => (
        <AddToProjectModal saleId={data.id} onClose={onClose} />
      ),
    });
  }, [data.id, dialog]);

  const addProjectAction: PopoverMenuType = {
    label: t('common:add_to_project'),
    onClick: onAddProject,
    isAllowed: addToProjectPermission,
    isError: false,
    key: `add-project-${data.id}`,
  };

  return {
    addProjectAction,
    permission,
    addToProjectPermission,
    onAddProject,
  };
}
